import { memo } from 'react'
import { Handle, Position, type NodeProps } from '@xyflow/react'
import { ChevronRight, ChevronDown } from 'lucide-react'

interface MindMapDocNodeData {
  docId: string
  label: string
  fullTitle: string
  status: string
  statusColor: string
  conceptCount: number
  expanded: boolean
  summary?: string
  dimmed: boolean
  [key: string]: unknown
}

function MindMapDocNodeComponent({ data }: NodeProps) {
  const d = data as MindMapDocNodeData

  return (
    <>
      <Handle type="target" position={Position.Left} className="!w-0 !h-0 !border-0 !bg-transparent" />
      <div
        className={`px-3 py-2.5 rounded-lg border cursor-pointer transition-all select-none min-w-[140px]
          ${d.expanded
            ? 'border-blue-400 dark:border-blue-500 bg-blue-50 dark:bg-blue-950/30 shadow-md'
            : 'border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 hover:border-blue-300 dark:hover:border-blue-600'
          }
          ${d.dimmed ? 'opacity-20' : 'opacity-100'}
        `}
      >
        <div className="flex items-center gap-2">
          {d.conceptCount > 0 && (
            d.expanded
              ? <ChevronDown className="w-3.5 h-3.5 text-blue-500 flex-shrink-0" />
              : <ChevronRight className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />
          )}
          <div
            className="w-2.5 h-2.5 rounded-full flex-shrink-0"
            style={{ backgroundColor: d.statusColor }}
          />
          <span className="text-sm font-medium text-gray-800 dark:text-gray-200 truncate max-w-[130px]">
            {d.label}
          </span>
          {d.conceptCount > 0 && (
            <span className="text-[10px] bg-blue-100 dark:bg-blue-900/40 text-blue-600 dark:text-blue-400 px-1.5 py-0.5 rounded-full flex-shrink-0">
              {d.conceptCount}
            </span>
          )}
        </div>
        <div className="text-[10px] text-gray-400 dark:text-gray-500 mt-0.5 ml-5 truncate max-w-[140px]">
          {d.docId}
        </div>
      </div>
      <Handle type="source" position={Position.Right} className="!w-0 !h-0 !border-0 !bg-transparent" />
    </>
  )
}

export const MindMapDocNode = memo(MindMapDocNodeComponent)
